import React from 'react';
import svgIcon from 'components/hoc/svgIcon';

const svg = () => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>10B6B07A-7B1A-4469-A071-9D3BA2840702</title>
    <defs>
      <circle id="path-1" cx="14" cy="14" r="14" />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Dropdown-" transform="translate(-1294.000000, -19.000000)">
        <g id="Account" transform="translate(1293.000000, 16.000000)">
          <g transform="translate(1.000000, 3.000000)" id="Group">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <use id="Oval" fill="#0091FF" fillRule="nonzero" xlinkHref="#path-1" />
            <path
              d="M20.9672019,21.8437333 L16.2482686,19.4842667 L16.2482686,17.5018667 C18.4994686,16.5162667 19.9816019,14.2874667 19.9816019,11.8222222 L19.9816019,9.33333333 C19.9816019,5.9024 17.190313,3.11111111 13.7593797,3.11111111 C10.3284463,3.11111111 7.53715746,5.9024 7.53715746,9.33333333 L7.53715746,11.8222222 C7.53715746,14.2874667 9.01929079,16.5162667 11.2704908,17.5018667 L11.2704908,19.5265778 L6.63617968,21.8437333 C4.77822412,22.7720889 4.16595746,25.4426667 3.9208019,26.5079111 C3.83617968,26.8675556 3.92204634,27.2421333 4.15226857,27.5333333 C4.38871301,27.8295111 4.74089079,28 5.12044634,28 L13.2217797,28 L14.3816019,28 L22.4841797,28 C22.8624908,28 23.215913,27.8307556 23.451113,27.5333333 C23.6825797,27.2433778 23.7672019,26.8700444 23.6688908,26.4407111 C23.4361797,25.4364444 22.8214241,22.7696 20.9672019,21.8437333 L20.9672019,21.8437333 Z"
              id="Path"
              fill="#F4F4F8"
              fillRule="nonzero"
              mask="url(#mask-2)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default svgIcon(svg);
